import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import HomeView from "@/views/HomeView.vue";
import MyProfileView from "@/views/MyProfileView.vue";
import LoginView from "@/views/LoginView.vue";

Vue.use(VueRouter);

export function checkRoute(next, to, permission) {
  if (store.getters["auth/hasPermission"](permission)) {
    // store.dispatch("routes/saveRoute", to.path);
    next();
  } else {
    next({
      name: "home",
      query: { redirectFrom: to.fullPath },
    });
  }
}

const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/home",
    name: "home",
    component: HomeView,
    meta: {
      showSystemBars: true,
      requiresAuth: true,
    },
  },
  {
    path: "/login",
    name: "login",
    component: LoginView,
    meta: {
      showSystemBars: false,
      requiresAuth: false,
    },
  },
  {
    path: "/profile",
    name: "profile",
    component: MyProfileView,
    meta: {
      showSystemBars: true,
      requiresAuth: true,
    },
  },
  {
    path: "/controle-carga/cargas/:identifier",
    name: "controle-carga-identifier",
    component: () => import("@/views/ControlDetailView.vue"),
    meta: {
      showSystemBars: true,
      requiresAuth: true,
    },
    beforeEnter(to, from, next) {
      checkRoute(next, to, "control.read");
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  // to and from are both route objects. must call `next`.)
  if (store.getters["auth/isAuthenticated"]) {
    if (to.path === "/login") {
      next("/");
    } else {
      next();
    }
  } else {
    if (to.path !== "/login") {
      next("/login");
    } else {
      next();
    }
  }
});

router.beforeResolve((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    store.dispatch("auth/tryRefreshToken");
  }
  next();
});

export default router;
